import styled, { css } from 'styled-components'

interface PropsFormControl {
  tabFocus: boolean;
  focus: boolean;
  error: boolean;
  disabled: boolean;
}

export const FormControl = styled.div<PropsFormControl>`
  display: flex;
  flex-direction: column;
  width:100%;
  .tabFocus {
    display: flex;
    flex-direction: column;
  }
  ${(props) =>
      props.tabFocus &&
      css`
      .tabFocus {
        ${(props) => props.theme.states.focus};
      }
    `}
  ${(props) =>
      props.focus &&
      css`
      label {
        ${(props) => props.theme.states.actived.label};
      }
      .input-wrapper {
        ${(props) => props.theme.states.actived.inputWrapper};
      }
    `}
  ${(props) =>
      !props.disabled &&
      css`
      &:hover {
        .input-wrapper {
          ${(props) => props.theme.states.hover.inputWrapper}
        }
      }
    `}
  ${(props) =>
      props.error &&
      css`
      label {
        ${(props) => props.theme.states.error.label}
      }
      .input-wrapper {
        ${(props) => props.theme.states.error.inputWrapper}
      }
      span {
        ${(props) => props.theme.states.error.helper}
      }
    `}
  ${(props) =>
      props.disabled &&
      css`
      label {
        ${(props) => props.theme.states.disabled.label}
      }
      .input-wrapper > input {
        ${(props) => props.theme.states.disabled.inputWrapper}
      }
      .input-wrapper  {
        ${(props) => props.theme.states.disabled.inputWrapper}
      }
      span {
        ${(props) => props.theme.states.disabled.helper}
      }
    `}'
`;

interface PropsLabel {
  htmlFor: string;
}

export const Label = styled.label<PropsLabel>`
  ${(props) => props.theme.label};
  ${(props) => props.theme.motion}
`;

export const InputWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  ${(props) => props.theme.inputWrapper};
  ${(props) => props.theme.motion}
  .tmp-icon {
    ${(props) => props.theme.icon}
  }
`;

interface PropsInput {
  capitalize: boolean;
}

export const Input = styled.input<PropsInput>`
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  width: 100%;
  text-transform: ${(props) => (props.capitalize ? "capitalize" : "none")};
  ${(props) => props.theme.input};
  ${(props) => props.theme.motion}
  &::placeholder {
    ${(props) =>
    props.disabled
      ? props.theme.states.disabled.placeholder
      : props.theme.placeholder};
  }
  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`;

interface PropsHelper {
  disabled: boolean;
}

export const Helper = styled.span<PropsHelper>`
  display: flex;
  ${(props) => props.theme.helper};
  .icon {
    ${(props) => props.theme.helper.icon};
  }

  .error{
    color: red;
  }
`;

export const Counter = styled.span`
  margin-left: auto;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`